/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AuthSettingsModule
 */

import { IAuthMatchAttribute } from 'generated-types';
import { AuthMatchAttribute } from 'object-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

/**
 * @description AuthMatchAttribute ConfigItem class.
 *
 * @author Aravindh Nagarajan
 */
export class AuthMatchAttributeConfigItem extends MessageItem<IAuthMatchAttribute> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: AuthMatchAttribute,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Returns true if criteria is defined.
     */
    public get hasCriteria(): boolean {
        return Boolean(this.config.criteria);
    }
}
